import { sessionService } from '@/providers/services/auth/session';
import { Vue, Component } from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import CommunityHubCreateComponent from '@/components/community-hub-create/community-hub-create';
import { communityHubAPI } from '@/providers/apis/community-hub/community-hub';

@Component({
    name: 'community-hub',
    components: {
        'material-icon': GoogleMaterialIcon,
        CommunityHubCreateComponent,
    },
})
export default class CommunityHubComponent extends Vue {
    // Properties
    public get session() {
        return sessionService.getSession();
    }

    public hubList: any = [];

    public offset: number = 0;

    public limit: number = 12;

    public perPage: number = 12;

    public isCreateHub: boolean = false;

    public isEditHub: boolean = false;

    public hubContent: any;

    public currentPage: number = 1;

    public totalCount: number = 0;

    public searchHubText: string = '';

    public isLoading: boolean = false;

    private searchAccessList: string = '';

    public created() {
        this.getCommunityList();
    }
    public searchAccessListClear() {
        this.searchHubText = '';
        this.getCommunityList();
    }
    public onSearch() {
        this.resetProperties();
        this.getCommunityList();
    }
    public onCreate() {
        this.isCreateHub = true;
    }
    public onEdit(list: any) {
        this.hubContent = list;
        this.isEditHub = true;
    }
    public onClose() {
        if (this.isCreateHub) {
            this.isCreateHub = false;
        }
        if (this.isEditHub) {
            this.isEditHub = false;
        }
        this.getCommunityList();
    }
    public getCommunityList() {
        this.isLoading = true;
        const cdnUrls = sessionService.getCdnUrl();
        const params: any = {
            limit: this.limit,
            offset: this.offset,
        };
        if (this.searchHubText) {
            params.searchKeyword = this.searchHubText;
        }
        communityHubAPI.getCommunityList(params).then((res: any) => {
            res.communityHubs.map((hub: any) => {
                const containsCdnUrl = hub.thumbnail.indexOf('https') !== -1;
                if (!containsCdnUrl) {
                    hub.thumbnail = cdnUrls.content_cdn_url + hub.thumbnail;
                } else {
                    hub.thumbnail = hub.thumbnail;
                }

            });
            this.isLoading = false;
            this.hubList = res.communityHubs;
            this.totalCount = res.totalCount;
        });
    }
    public onSelectPage(pageNumber: number) {
        this.currentPage = pageNumber;
        this.offset = (pageNumber - 1) * this.limit;
        this.getCommunityList();
    }
    public resetProperties() {
        this.limit = 10;
        this.offset = 0;
        this.currentPage = 1;
    }
}
